import { render, staticRenderFns } from "./ProspectProjectDetails.vue?vue&type=template&id=077e4552&scoped=true"
import script from "./ProspectProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProspectProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./ProspectProjectDetails.vue?vue&type=style&index=0&id=077e4552&prod&scoped=true&lang=css"
import style1 from "./ProspectProjectDetails.vue?vue&type=style&index=1&id=077e4552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e4552",
  null
  
)

export default component.exports